// Models
import Model from './Model'

class PaymentOrderForexData extends Model {
  get schema () {
    return [
      'buyAmount',
      'buyCurrency',
      'rate'
    ]
  }
}

export default PaymentOrderForexData
